import { SkeletonTypography } from '@apeiron/temp'
import { ApeironTooltipInfoButton } from '@apeiron/ui'
import { Box, styled, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'

const Container = styled(Box)`
  align-items: center;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px 10px;
`

const TitleContainer = styled(Box)`
  align-items: center;
  display: flex;
  gap: 8px;
`

const Title = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  line-height: 16px;
  white-space: nowrap;
`

const InfoButton = styled(ApeironTooltipInfoButton)`
  .Custom-Button {
    .Custom-Button-Icon {
      width: 17px;
    }
  }
`

const Value = styled(Typography)`
  font-size: 34px;
  font-weight: 500;
  line-height: 34px;
`

const ExtraValue = styled(SkeletonTypography)`
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  &.Custom-Typography-Skeleton {
    width: 60%;
  }
`

const BurnPreviewSection: FC<Props> = props => {
  const {
    className,
    explain,
    extraValue,
    title,
    tooltipId,
    value,
    extraTextLoading
  } = props

  return (
    <Container className={className}>
      <TitleContainer>
        <Title>{title}</Title>
        <InfoButton tooltipId={tooltipId}>{explain}</InfoButton>
      </TitleContainer>
      <Value>{value}</Value>
      <ExtraValue
        className='Custom-Extra-Value'
        loading={extraTextLoading}
      >{`+${extraValue}`}</ExtraValue>
    </Container>
  )
}

type Props = {
  className?: string
  explain: ReactNode
  extraValue: string
  title: string
  tooltipId: string
  value: string
  extraTextLoading?: boolean
}

export default BurnPreviewSection
